import {RouteConfig} from 'vue-router'
import Layout from '@/layout/index.vue'

const equipRouter: RouteConfig = {
  path: '/equiptypeManage',
  redirect: 'noredirect',
  name: 'equiptypeManage',
  component: Layout,
  children: [
    {
      path: 'equiptypeManage',
      component: () => import('@/views/equiptypeManage/index.vue'),
      name: 'Apparatus',
      meta: {
        title: '器材类型管理',
        icon: 'equiptype',
        requireAuth: true
      }
    },
  ]

}

export default equipRouter
